import {Controller} from "@hotwired/stimulus"

export class ClipboardController extends Controller {
	static targets = ["button", "source"]

	static values = {
		successContent: String,
		successDuration: {
			type: Number, default: 3000,
		},
	}

	connect() {
		this.originalContent = this.buttonTarget.innerHTML
	}

	copy(event) {
		event.preventDefault()
		event.stopPropagation()

		const text = this.sourceTarget.innerHTML || this.sourceTarget.value

		navigator.clipboard.writeText(text).then(() => this.copied())
	}

	copied() {
		if (this.timeout) clearTimeout(this.timeout)

		console.log(this.successContentValue)

		this.buttonTarget.innerHTML = this.successContentValue

		this.timeout = setTimeout(() => {
			this.buttonTarget.innerHTML = this.originalContent
		}, this.successDurationValue)
	}
}